import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const GuestLinkDataResponseSchema = z.object({
    filespaceId: z.string(),
    workspaceId: z.string(),
    fsEntryId: z.string(),
});
export class GuestLinkDataResponseDto extends createZodDto(GuestLinkDataResponseSchema) {
}
